/**
 * Fire alarm siren via the Web Audio API.
 *
 * Avoids embedding an audio file: builds a square-wave oscillator that
 * toggles on/off at 1Hz to create a two-tone siren effect. AudioContext
 * can only be created/resumed after a user gesture in most browsers, so
 * the factory is called lazily when the alarm actually triggers. The
 * returned handle's `stop()` ends the loop and closes the context.
 */
export interface SirenHandle {
  stop: () => void;
  /** True if the AudioContext is currently running (i.e. audio is
   *  audible). False when suspended / not yet started. */
  isPlaying: () => boolean;
}

export type SirenFactory = () => SirenHandle | null;

let sharedFactory: SirenFactory | null = null;

export function setSirenFactory(factory: SirenFactory | null): void {
  sharedFactory = factory;
}

export function getSirenFactory(): SirenFactory | null {
  return sharedFactory;
}
